module.exports = __webpack_public_path__ + "fonts/trust_sans_regular_it-webfont.af9309e3.woff2";